import React, { useState } from 'react';
import { toast } from 'react-toastify';

import { Grid } from '@mui/material';
import { Button } from 'components';
import { Form, Formik } from 'formik';
import { downloadcsv } from 'helpers/downloadcsv';
import { PageTitle } from 'pages/Layout/PageTitle';
import { providerService } from 'services/providers';

export const WhereUsedReport = () => {
  const [isLoading, setIsLoading] = useState(false);
  const handleExport = async (values) => {
    toast.info('Relatório sendo gerado...');
    setIsLoading(true);
    try {
      const { data } = await providerService.whereUsedReport();

      if (data.status === 200) {
        toast.success(data.msg);
        downloadcsv('ingenico_where_used_', data.result);
        setIsLoading(false);
      } else {
        toast.error(data.msg);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error.message);
      toast.error('Erro ao gerar relatório');
      setIsLoading(false);
    }
  };
  return (
    <>
      <PageTitle>Where Used - PN X Modelo</PageTitle>

      <Formik
        initialValues={{ input_data: new Date(), output_data: new Date() }}
        onSubmit={handleExport}
      >
        {(props) => (
          <Form>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4} md={4} lg={3}>
                <Button type='submit' fullWidth loading={isLoading}>
                  Extrair Relatório
                </Button>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
    </>
  );
};
